module.exports = __webpack_public_path__ + "static/media/pao.73c22115.svg";